import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import { Driver } from '../../../types/driver';
import getAuth from '../../../utils/api/getToken';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Driver`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const driversApi = createApi({
  reducerPath: 'drivers',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0,
  tagTypes: ['Drivers'],
  endpoints: (builder) => ({
    getDrivers: builder.query<Driver[], { search: string; companyId: string }>({
      query: ({ search, companyId }) => {
        return `/getAllDrivers?driverSearch=${search}&companyId=${companyId}`;
      },
      providesTags: (res, err, driver) => [{ type: 'Drivers' }],
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetDriversQuery } = driversApi;
